// extracted by mini-css-extract-plugin
export var autoExpand = "_2u-8";
export var container = "_2u-7";
export var containerWidth = "_2u-5";
export var disabled = "_2u-2";
export var error = "_2u-3";
export var fullWidth = "_2u-6";
export var inputWrapper = "_2u-0";
export var small = "_2u-1";
export var textarea = "_2u-4";